import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useConsultantAuthStore from "../../store/consultant/useConsultantAuthStore";
import ConsultantProfile from "./ConsultantProfile";
import ConsultantLayout from "../../layout/consultant/ConsultantLayout";

const ConsultantDashboard = () => {
    const { consultant, token, getProfile } = useConsultantAuthStore();
    const navigate = useNavigate();

    useEffect(() => {
        if (!token && !consultant) {
            navigate("/consultant/login");
        } else if (!consultant) {
            getProfile();
        }
    }, [token, consultant, navigate, getProfile]);

    if (!consultant) {
        return (
            <Box className="flex items-center justify-center min-h-screen">
                <Typography>Loading...</Typography>
            </Box>
        );
    }

    return (
        <ConsultantLayout>
            <Box className="bg-white rounded-lg shadow-sm p-6">
                <ConsultantProfile consultant={consultant} />
            </Box>
        </ConsultantLayout>
    );
};

export default ConsultantDashboard;
